const status = [
  { value: 'true', label: 'Ativo' },
  { value: 'false', label: 'Inativo' },
];

export default status;
